import ModalSelectPatient from "./ModalSelectPatient";

export default ModalSelectPatient;